/**
 * @module use-cases/order/actions
 * @desc Order Action Creators
 *
 */

import type { Order } from 'core/domains';
import { createAction, createAsyncAction } from 'core/use-cases/utilities';

export const orderCleanUp = createAction('orderCleanUp');

export const orderFetch = createAsyncAction<'orderFetch', undefined, Order['data']>('orderFetch');
